import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import loadCarouselProducts from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import { getProductsForProductInfoList } from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import { getSelectedImage } from "@insite/client-framework/Store/Pages/ProductDetails/ProductDetailsSelectors";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import Button, { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import DataTable from "@insite/mobius/DataTable";
import DataTableBody from "@insite/mobius/DataTable/DataTableBody";
import DataTableHead from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconProps } from "@insite/mobius/Icon";
import ArrowDown from "@insite/mobius/Icons/ArrowDown";
import ArrowUp from "@insite/mobius/Icons/ArrowUp";
import ChevronLeft from "@insite/mobius/Icons/ChevronLeft";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ExplodedViewProductCard from "@store/Components/ExplodedView/ExplodedViewProductCard";
import ExplodedViewProductRow from "@store/Components/ExplodedView/ExplodedViewProductRow";
import Tool from "@store/Components/Icons/Tool";
import { arrowButton } from "@store/Extensions/Widgets/Common/ProductCarousel";
import setSelectedSubAssembly from "@store/Store/Data/ExplodedView/Handlers/SetSelectedAssembly";
import StoreApplicationState from "@store/Store/StoreApplicationState";
import { COLORS, TYPOGRAPHY } from "@store/theme/design";
import { BubbleDataModel } from "@store/Types/ApiModels";
import scrollToId from "@store/utilities/scrollToId";
import find from "lodash/find"; // Store Custom Code
import findIndex from "lodash/findIndex"; // Store Custom Code
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    displayAsTable: boolean;
    product: ProductModel;
}

interface OrderedProducts {
    [key: string]: ProductModel;
}

export interface ExplodedViewItemsStyles {
    tableWrapper?: InjectableCss;
    listWrapper?: InjectableCss;
    listItemsWrapperContainer?: InjectableCss;
    listItemsWrapper?: InjectableCss;
    listViewTitleWrapper?: InjectableCss;
    listViewCountWrapper?: InjectableCss;
    listViewCountTitle?: TypographyPresentationProps;
    listViewTitle?: TypographyPresentationProps;
    tableHeader?: DataTableHeaderProps;
    toolIcon?: IconProps;
    mainContainer?: GridContainerProps;
    prevArrowGridItem?: GridItemProps;
    prevArrowButton?: ButtonPresentationProps;
    nextArrowGridItem?: GridItemProps;
    nextArrowButton?: ButtonPresentationProps;
}

const mapStateToProps = (state: StoreApplicationState, ownProps: OwnProps) => ({
    products: getProductsForProductInfoList(state, "explodedViewItems"),
    userName: state.context.session?.userName,
    selectedSubAssembly: state.store?.data?.explodedView?.selectedSubAssembly,
    selectedImage: getSelectedImage(state, ownProps.product),
    selectedImageIndex: state.pages.productDetails.selectedImageIndex,
});

const mapDispatchToProps = {
    loadCarouselProducts,
    setSelectedSubAssembly,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const listWrapper = css`
    display: flex;
    flex-direction: column;
`;

const listItemsWrapperContainer = css`
    position: relative;
    flex-grow: 1;
`;

const listItemsWrapper = css`
    position: absolute;
    top: 150px;
    bottom: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
`;

export const explodedViewItemsStyles: ExplodedViewItemsStyles = {
    tableWrapper: {
        css: css`
            overflow: auto;
            border: 1px solid ${COLORS.border.base};
        `,
    },
    listWrapper: {
        css: css`
            position: relative;
            height: 100%;
            border: 1px solid ${COLORS.border.base};
            background: ${getColor("common.disabledLight")};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css``,
                    css``,
                    css`
                        ${listWrapper}
                    `,
                    css`
                        ${listWrapper}
                    `,
                    css`
                        ${listWrapper}
                    `,
                ])}
        `,
    },
    listItemsWrapperContainer: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css``,
                    css``,
                    css`
                        ${listItemsWrapperContainer}
                    `,
                    css`
                        ${listItemsWrapperContainer}
                    `,
                    css`
                        ${listItemsWrapperContainer}
                    `,
                ])}
        `,
    },
    listItemsWrapper: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css``,
                    css``,
                    css`
                        ${listItemsWrapper}
                    `,
                    css`
                        ${listItemsWrapper}
                    `,
                    css`
                        ${listItemsWrapper}
                    `,
                ])}
        `,
    },
    listViewCountTitle: {
        css: css``,
    },
    listViewTitleWrapper: {
        css: css`
            background: ${getColor("primary.contrast")};
            padding: 20px;
        `,
    },
    listViewCountWrapper: {
        css: css`
            font-size: ${TYPOGRAPHY.size.smaller};
            padding: 1em 1em 0.5em 0.5em;
        `,
    },
    listViewTitle: {
        size: 24,
        css: css`
            color: ${getColor("primary.main")};
            font-weight: ${TYPOGRAPHY.weight.bold};
        `,
    },
    tableHeader: {
        style: {
            background: `${COLORS.text.light}`,
        },
        typographyProps: {
            color: "white",
        },
    },
    toolIcon: {
        src: Tool,
        color: COLORS.primary.base,
        size: 22,
        css: css`
            position: relative;
            top: 0.15em;
        `,
    },
    mainContainer: {
        gap: 0,
        css: css`
            margin: 0;
            width: 100%;
        `,
        offsetCss: css`
            margin-bottom: 15px;
            width: 100%;
        `,
    },
    prevArrowGridItem: {
        width: 6,
        align: "middle",
        css: css`
            justify-content: center;
        `,
    },
    prevArrowButton: {
        variant: "secondary",
        color: "text.main",
        css: css`
            ${arrowButton()}
            border: 0;
            padding: 0;
        `,
        icon: {
            src: ArrowUp,
            position: "left",
        },
    },
    nextArrowGridItem: {
        width: 6,
        align: "middle",
        css: css`
            justify-content: center;
        `,
    },
    nextArrowButton: {
        variant: "secondary",
        color: "text.main",
        css: css`
            ${arrowButton()}
            border: 0;
            padding: 0;
        `,
        icon: {
            src: ArrowDown,
            position: "left",
        },
    },
};

const styles = explodedViewItemsStyles;

const ExplodedViewItems: React.FC<Props> = ({
    products,
    userName,
    displayAsTable,
    selectedSubAssembly,
    setSelectedSubAssembly,
    selectedImageIndex,
}) => {
    const [scrollPadding, setScrollPadding] = React.useState(0);
    const [orderedProducts, setOrderedProducts] = React.useState<OrderedProducts>({});
    const itemsZone = React.useRef<HTMLDivElement | null>(null);
    const itemsWrapper = React.useRef<HTMLDivElement | null>(null);

    const handleWindowSizeChange = () => {
        setScrollPadding(0);
        if (itemsZone.current && itemsWrapper.current) {
            const itemsWrapperLastChild = itemsWrapper.current.lastElementChild as HTMLDivElement;
            if (itemsWrapperLastChild) {
                const lastChildHeight: number = itemsWrapperLastChild.offsetHeight;
                const itemsZoneHeight: number = itemsZone.current.offsetHeight - 16;
                setScrollPadding(itemsZoneHeight - lastChildHeight);
            }
        }
    };

    const selectItemCallback = (id: string) => {
        setSelectedSubAssembly({
            selectedSubAssembly: id,
        });
    };

    React.useEffect(() => {
        handleWindowSizeChange();
    }, [products]);

    React.useEffect(() => {
        if (typeof window !== "undefined") {
            window.addEventListener("resize", handleWindowSizeChange);
            return () => {
                window.removeEventListener("resize", handleWindowSizeChange);
            };
        }
    }, []);

    React.useEffect(() => {
        return () => {
            setSelectedSubAssembly({
                selectedSubAssembly: "",
            });
        };
    }, []);
    React.useEffect(() => {
        if (selectedSubAssembly) {
            const item = document.querySelectorAll<HTMLElement>(`[data-sku="${selectedSubAssembly}"]`)[0];
            const navigator = document.getElementById(`explodedViewNavigator`);
            if (item && navigator && itemsWrapper.current) {
                itemsWrapper.current.scrollTop = item.offsetTop;
                navigator.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
            }
        }
    }, [selectedSubAssembly]);

    const listItemsWrapper: InjectableCss = {
        css: css`
            ${styles.listItemsWrapper?.css}
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-bottom: 0;
                    `,
                    css`
                        padding-bottom: 0;
                    `,
                    css`
                        padding-bottom: ${scrollPadding}px;
                    `,
                    css`
                        padding-bottom: ${scrollPadding}px;
                    `,
                    css`
                        padding-bottom: ${scrollPadding}px;
                    `,
                ])}
        `,
    };

    React.useEffect(() => {
        if (!products) {
            return;
        }
        const productsWithBubbleId = {} as OrderedProducts;
        products.forEach(product => {
            if (!product.properties.bubbleData) {
                return null;
            }

            const bubbles: BubbleDataModel[] = JSON.parse(product.properties.bubbleData);
            return bubbles.forEach((bubble: BubbleDataModel) => {
                const { PageNo, BubbleId } = bubble;
                const currentPage = selectedImageIndex + 1;
                if (parseInt(PageNo, 10) !== currentPage) {
                    return null;
                }
                productsWithBubbleId[`${BubbleId}//${product.id}`] = product;
            });
        });
        const sortedKeys = Object.keys(productsWithBubbleId).sort((a, b) => {
            const aPrefix = a.split("//")[0];
            const bPrefix = b.split("//")[0];
            return aPrefix.localeCompare(bPrefix, undefined, { numeric: true });
        });

        const sortedAllItems: OrderedProducts = {};
        sortedKeys.forEach(key => {
            sortedAllItems[key] = productsWithBubbleId[key];
        });
        setOrderedProducts(sortedAllItems);
    }, [products]);

    const selectedProductIndex = React.useMemo(() => {
        if (!orderedProducts) {
            return -1;
        }
        const keysArray = Object.keys(orderedProducts);
        const index = keysArray.findIndex(key => key === selectedSubAssembly);
        return index;
    }, [selectedSubAssembly, orderedProducts, products]);

    const scrollNext = () => {
        if (orderedProducts) {
            const keysArray = Object.keys(orderedProducts);
            const orderedProductsArray = Object.values(orderedProducts);
            if (selectedProductIndex === orderedProductsArray.length) {
                setSelectedSubAssembly({
                    selectedSubAssembly: keysArray[0],
                });
                return;
            }
            setSelectedSubAssembly({
                selectedSubAssembly: keysArray[selectedProductIndex + 1],
            });
        }
    };

    const scrollPrev = () => {
        if (orderedProducts) {
            const keysArray = Object.keys(orderedProducts);
            const orderedProductsArray = Object.values(orderedProducts);
            if (selectedProductIndex === 0) {
                setSelectedSubAssembly({
                    selectedSubAssembly: keysArray[orderedProductsArray.length],
                });
                return;
            }
            setSelectedSubAssembly({
                selectedSubAssembly: keysArray[selectedProductIndex - 1],
            });
        }
    };

    return (
        <>
            {!displayAsTable && products && orderedProducts && (
                <StyledWrapper {...styles.listWrapper} ref={itemsZone}>
                    <StyledWrapper>
                        <StyledWrapper {...styles.listViewTitleWrapper}>
                            <Typography {...styles.listViewTitle}>
                                <Icon {...styles.toolIcon} /> {translate("Assembly parts list")}
                            </Typography>
                        </StyledWrapper>
                        <StyledWrapper {...styles.listViewCountWrapper}>
                            <Typography {...styles.listViewCountTitle}>
                                {Object.keys(orderedProducts)?.length} {translate("items")}
                            </Typography>
                        </StyledWrapper>
                    </StyledWrapper>
                    <StyledWrapper>
                        <GridContainer {...styles.mainContainer}>
                            <GridItem {...styles.prevArrowGridItem}>
                                <Button
                                    disabled={selectedProductIndex === 0 || selectedProductIndex === -1}
                                    onClick={() => scrollPrev()}
                                    {...styles.prevArrowButton}
                                >
                                    <ButtonIcon src={ChevronLeft} />
                                </Button>
                            </GridItem>
                            <GridItem {...styles.nextArrowGridItem}>
                                <Button
                                    disabled={selectedProductIndex === Object.keys(orderedProducts).length - 1}
                                    onClick={() => scrollNext()}
                                    {...styles.nextArrowButton}
                                >
                                    <ButtonIcon src={ChevronRight} />
                                </Button>
                            </GridItem>
                        </GridContainer>
                    </StyledWrapper>
                    <StyledWrapper {...listItemsWrapper} ref={itemsWrapper}>
                        {Object.keys(orderedProducts).map(key => {
                            const product = orderedProducts[key];
                            if (!product || !product.properties.bubbleData) {
                                return null;
                            }
                            const regex = /^(.*?)\/\//;
                            const match = key.match(regex);
                            if (!match) {
                                return null;
                            }
                            const bubbleId = match[1];
                            const bubbles: BubbleDataModel[] = JSON.parse(product.properties.bubbleData);
                            const currentBubble: BubbleDataModel =
                                find(bubbles, { BubbleId: bubbleId } as any) || bubbles[0];
                            if (!bubbleId || !bubbles) {
                                return null;
                            }
                            return (
                                <ExplodedViewProductCard
                                    product={product}
                                    key={key}
                                    productNumber={product.productNumber}
                                    productTitle={product.productTitle}
                                    id={key}
                                    selectionCallback={selectItemCallback}
                                    index={bubbleId}
                                    qty={currentBubble.Qty}
                                ></ExplodedViewProductCard>
                            );
                        })}
                    </StyledWrapper>
                </StyledWrapper>
            )}
            {displayAsTable && products && (
                <StyledWrapper {...styles.tableWrapper}>
                    <DataTable>
                        <DataTableHead>
                            <DataTableHeader {...styles.tableHeader} title="BubbleId"></DataTableHeader>
                            <DataTableHeader {...styles.tableHeader} title="Image"></DataTableHeader>
                            <DataTableHeader {...styles.tableHeader} title="Name">
                                {translate("Name")}
                            </DataTableHeader>
                            <DataTableHeader {...styles.tableHeader} title="Brand">
                                {translate("Brand")}
                            </DataTableHeader>
                            <DataTableHeader {...styles.tableHeader}>{translate("SKU")}</DataTableHeader>
                            {userName ? (
                                <>
                                    <DataTableHeader {...styles.tableHeader}>{translate("Quantity")}</DataTableHeader>
                                    <DataTableHeader {...styles.tableHeader}>{translate("Unit Price")}</DataTableHeader>
                                </>
                            ) : (
                                <DataTableHeader {...styles.tableHeader}></DataTableHeader>
                            )}

                            <DataTableHeader {...styles.tableHeader} title="ViewProduct"></DataTableHeader>
                        </DataTableHead>
                        <DataTableBody>
                            {Object.keys(orderedProducts).map(key => {
                                const product = orderedProducts[key];
                                if (!product || !product.properties.bubbleData) {
                                    return null;
                                }
                                const regex = /^(.*?)\/\//;
                                const match = key.match(regex);
                                if (!match) {
                                    return null;
                                }
                                const bubbleId = match[1];
                                const bubbles: BubbleDataModel[] = JSON.parse(product.properties.bubbleData);
                                const currentBubble: BubbleDataModel =
                                    find(bubbles, { BubbleId: bubbleId } as any) || bubbles[0];
                                if (!bubbleId || !bubbles) {
                                    return null;
                                }
                                return (
                                    <ExplodedViewProductRow
                                        product={product}
                                        key={key}
                                        productNumber={product.productNumber}
                                        productTitle={product.productTitle}
                                        id={key}
                                        selectionCallback={selectItemCallback}
                                        index={bubbleId}
                                        qty={currentBubble.Qty}
                                    ></ExplodedViewProductRow>
                                );
                            })}
                        </DataTableBody>
                    </DataTable>
                </StyledWrapper>
            )}
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ExplodedViewItems);
